import React from 'react';

class UIIconSelect extends React.Component
{
	render()
	{
		const { options, iconClass, onChange, value, className } = this.props;

		const selectClassName = `ui-select ui-icon-select ${className || ''}`.trim();

		return (
			<div className={selectClassName}>
				<p className={`icon ${iconClass}`} />
				<select
					value={value}
					onChange={e => onChange({ value: e.target.value, label: e.target.options[e.target.selectedIndex].text })}
					className="ui-select-select"
				>
					{options.map(option => (
						<option key={option.value} value={option.value}>
							{option.label}
						</option>
					))}
				</select>
			</div>
		);
	}
}

export default UIIconSelect;